import { API_PERIOD_CONFIGURABLES } from "../../utils/apis";
import { getRegister } from "../../utils/helpers";
import { URL_PERIOD_CONFIGURABLES } from "../../utils/urls";

export const usePeriodConfigurablesForm = ({ form }) => {
  const sections = [
    {
      title: "Configurable Details",
      fields: [
        {
          field_name: "validity_period",
          type: "number",
          label: "Validity Period",
          props: { required: true, step: "0.01" },
        },
        {
          field_name: "number_of_months",
          type: "number",
          label: "Number of Months",
          props: { required: true, disabled: true },
          visible: form?.number_of_months > 0,
        },
      ],
    },
  ];

  const redirect = getRegister(URL_PERIOD_CONFIGURABLES);

  return {
    sections,
    redirect,
  };
};

export function submitPeriodConfigurables(payload: any, id: string) {
  //  on update
  if (id) {
    return {
      id,
      api: API_PERIOD_CONFIGURABLES,
      params: payload,
    };
  }
  // on create
  return {
    api: API_PERIOD_CONFIGURABLES,
    params: payload,
  };
}
